"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLIENT_TYPE_ROLE_MAP = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
exports.CLIENT_TYPE_ROLE_MAP = {
    [legacy_enums_1.ClientType.Website]: ["site-customer-customer-interface"],
    [legacy_enums_1.ClientType.iOS]: ["site-customer-customer-interface"],
};
//# sourceMappingURL=appRoles.js.map